var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 22.6L16.775 19.575C16.3583 19.8417 15.9167 20.0708 15.45 20.2625C14.9833 20.4542 14.5 20.6083 14 20.725V18.675C14.2333 18.5917 14.4625 18.5083 14.6875 18.425C14.9125 18.3417 15.125 18.2417 15.325 18.125L12 14.8V20L6.99999 15H2.99999V8.99999H6.19999L1.39999 4.19999L2.79999 2.79999L21.2 21.2L19.8 22.6ZM19.6 16.8L18.15 15.35C18.4333 14.8333 18.6458 14.2917 18.7875 13.725C18.9292 13.1583 19 12.575 19 11.975C19 10.4083 18.5417 9.00832 17.625 7.77499C16.7083 6.54165 15.5 5.70832 14 5.27499V3.22499C16.0667 3.69165 17.75 4.73749 19.05 6.36249C20.35 7.98749 21 9.85832 21 11.975C21 12.8583 20.8792 13.7083 20.6375 14.525C20.3958 15.3417 20.05 16.1 19.6 16.8ZM16.25 13.45L14 11.2V7.94999C14.7833 8.31666 15.3958 8.86665 15.8375 9.59999C16.2792 10.3333 16.5 11.1333 16.5 12C16.5 12.25 16.4792 12.4958 16.4375 12.7375C16.3958 12.9792 16.3333 13.2167 16.25 13.45ZM12 9.19999L9.39999 6.59999L12 3.99999V9.19999Z",
    fill: "#BCB9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteIcon);
export default __webpack_public_path__ + "static/media/mute-icon.3f200cc0c55fb77f4725b59f6eb239a4.svg";
export { ForwardRef as ReactComponent };